<?php

Namespace Controller ;

class RegisterController extends \Controller\Base {

    public function execute($pageVars) {
        $page_model = new \Model\Register\PageModel() ;
        $page = $page_model->getPage($pageVars) ;
        \ISOPHP\js_core::$console->log('Register control pagevars', $pageVars) ;
//        \ISOPHP\js_core::$window->document->title = $page['title'] ;
        $res = new \Controller\Result() ;
        if ($pageVars['route']['action'] == 'attempt') {
            $data = $page_model->getRegisterEmployeeResult($pageVars);
            \ISOPHP\js_core::$console->log('Register Controller Attempt Result', $data);
            $res->type = null; # no type means no further action
            \ISOPHP\js_core::$console->log('Register Con attempt action', $res);
            return $res;
        }
        if ($pageVars['route']['action'] == 'hiring-interest-reg-attempt') {
            $data = $page_model->getRegisterHiringResult($pageVars);
            \ISOPHP\js_core::$console->log('One Register Controller Hiring Interest Registration Attempt', $data) ;
            $res->type = null ; # no type means no further action
            \ISOPHP\js_core::$console->log('One Register Controller Hiring Interest Registration Attempt Result', $res) ;
            return $res ;
        }
        if ($pageVars['route']['action'] == 'hiring') {
            $res->page = $page ;
            $res->view = 'RegisterHiring.php' ;
            $res->type = 'view' ;
            $res->view_control = 'Register' ;
            $res->post_template = array() ;
            $res->post_template[] = $page_model->bindButtons() ;
            //$res->post_template[] = $page_model->bindMockIProov($pageVars) ;
            //$res->post_template[] = $page_model->getMockIProovResult($pageVars) ;
            \ISOPHP\js_core::$console->log('Register Con hiring page action', $res) ;
            return $res ;
        }
        if ($pageVars['route']['action'] == 'employee'){
            $res->page = $page ;
            $res->view = 'RegisterEmployee.php' ;
            $res->type = 'view' ;
            $res->view_control = 'Register' ;
            $res->post_template = array() ;
            $res->post_template[] = $page_model->bindButtons() ;
            \ISOPHP\js_core::$console->log('Register Con employee action', $res) ;
            return $res ;
        }
    }

}


// WEBPACK FOOTER //
// app/Register/Controller/RegisterController.php